<template>
  <div>
    <v-form ref="currencyForm" @submit.prevent="">
      <v-row>
        <v-col class="col-12 col-sm-6 col-md-3">
          <v-text-field
            v-model="currencyModel"
            :label="$t('changeCurrency.currency')"
            :rules="[(v) => !!v || $t('changeCurrency.currencyNotEmpty')]"
            outlined
          />
        </v-col>

        <v-col class="col-4">
          <v-btn
            class="mt-2"
            color="primary"
            outlined
            @click="sendChangeRequest()"
          >
            <span class="mr-2" />
            {{ $t('changeCurrency.changeLable') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import store from '../../store/store'

export default {
  name: 'ChangeCurrrency',
  data() {
    return {
      currencyModel: store.getters
        .getCurrentDestinationInstance()
        .getCurrency(),
    }
  },
  methods: {
    sendChangeRequest() {
      if (!this.$refs.currencyForm.validate()) return
      const destination = store.getters.getCurrentDestinationInstance()
      destination.setCurrency(this.currencyModel)
      destination.updateCurrency(this.currencyModel)
    },
  },
}
</script>
